import { Types } from './types'

const initialState = {
    dataShop: {
        rows: [],
        paging: {}
    }
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_SHOP:
            return {
                ...newState,
                dataShop: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
